var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedflightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.451,
    height: 52.499,
    viewBox: "0 0 28.451 52.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M327.821-69.682a.6.6,0,0,1,.564.033L332.2-67.3a.6.6,0,0,0,.582.024l11.811-5.991a12.247,12.247,0,0,1,6.884-1.7s2.784-.3,2.484,1.692c-.288,1.912-6.46,4.554-8.348,5.107a.581.581,0,0,0-.328.251l-3.853,6.1a.6.6,0,0,1-.286.237l-2.336.918a.6.6,0,0,1-.813-.519l-.2-3.23a.6.6,0,0,0-.809-.521,31.141,31.141,0,0,1-9.88,2.175c-.428,0,.479-1.078,1.023-1.684a.594.594,0,0,0-.011-.806L325.7-67.827a.6.6,0,0,1,.182-.95Z",
    transform: "translate(-325.533 75)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M349.465-47.132H328.229a.792.792,0,0,0-.7.862v4.447a.792.792,0,0,0,.7.862h.073v1.6a.2.2,0,0,0,.174.216H330.3a.2.2,0,0,0,.174-.216v-1.6h16.739v1.6a.2.2,0,0,0,.174.216h1.828a.2.2,0,0,0,.174-.216v-1.6h.072a.792.792,0,0,0,.7-.862V-46.27a.792.792,0,0,0-.7-.862",
    transform: "translate(-327.533 47.132)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M329.748-46.3h.554v-2.3a.729.729,0,0,1,.738-.719h5.875a.729.729,0,0,1,.738.719v2.3h2.122v-2.3a.728.728,0,0,1,.738-.719h5.875a.729.729,0,0,1,.738.719v2.3h.554a2.186,2.186,0,0,1,2.215,2.156v-5.831a2.186,2.186,0,0,0-2.215-2.156H329.748a2.186,2.186,0,0,0-2.215,2.156v5.831a2.186,2.186,0,0,1,2.215-2.156",
    transform: "translate(-327.533 52.132)",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8061",
    "data-name": "Group 8061",
    transform: "translate(-343.33 -16.771)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(351.267 46.952)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")), /*#__PURE__*/React.createElement("g", {
    id: "airplane",
    transform: "translate(343.33 16.771)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M324.46-76.166H356.5v17.941H324.46Z",
    transform: "translate(-326.174 74.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bed",
    transform: "translate(346.525 53.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8034",
    "data-name": "Group 8034",
    transform: "translate(0 7.986)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M326.533-48.132h25.822v11.181H326.533Z",
    transform: "translate(-328.13 46.534)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8035",
    "data-name": "Group 8035",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M326.533-53.132h25.556v11.181H326.533Z",
    transform: "translate(-328.13 51.534)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedflightIcon);
export default __webpack_public_path__ + "static/media/bedflight-icon.383a8f605f7c339c43fccdc3c55faac1.svg";
export { ForwardRef as ReactComponent };